// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".media-card-image{align-items:center;display:flex;height:100%;justify-content:center}.media-card-image a{-webkit-text-decoration:none;text-decoration:none}.media-card-image img{height:auto}@media(max-height:768px){.media-card-image img{max-height:80vh}}@media(min-height:768px){.media-card-image img{max-height:41.25rem}}@media(max-width:768px){.media-card-image img{max-height:30.75rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
